import { assert } from '@Utils/assert';
import RequestUrls from '@Constants/RequestUrlsConstants';

const CriticalRequestUrls = Object.values(RequestUrls).filter(({ critical }) => critical);

CriticalRequestUrls.forEach((requestUrlInstance) => {
  assert(
    requestUrlInstance.urlRegex instanceof RegExp,
    `requestUrlInstance.urlRegex has to be instance of RegExp but it is ${requestUrlInstance.urlRegex}`
  );
});

export default CriticalRequestUrls;
